import {useMutation} from '@apollo/react-hooks';

import type {
    AddPdlContactsToAccount as AddPdlContactsToAccountMutation,
    AddPdlContactsToAccountVariables as AddPdlContactsToAccountMutationVariables,
    AccountPdlContactsAddInput,
} from 'nutshell-graphql-types';

import ADD_CONTACTS from '../mutations/add-pdl-contacts-to-account.graphql';

export function useAddPdlContactsToAccount(): {
    addContacts: (arg1: AccountPdlContactsAddInput) => Promise<any>;
    isAdding: boolean;
} {
    const [addContacts, {loading}] = useMutation<
        AddPdlContactsToAccountMutation,
        AddPdlContactsToAccountMutationVariables
    >(ADD_CONTACTS);

    return {
        addContacts: (input: AccountPdlContactsAddInput) =>
            addContacts({
                variables: {input},
            }),
        isAdding: loading,
    };
}
